import Resource from './Resource'

class User extends Resource {
  constructor(data) {
    if (!data) {
      data = {
        personal: {},
        contact: {},
        consent: {},
        security: {},
        identifiers: {},
      }
    }

    super(data)
  }

  get id() {
    return this.data._id
  }

  set id(val) {
    return this.data._id = val
  }

  get firstName() {
    return this.data.personal.first_name
  }

  set firstName(val) {
    return this.data.personal.first_name = val
  }

  get lastName() {
    return this.data.personal.last_name
  }

  set lastName(val) {
    return this.data.personal.last_name = val
  }

  get gender() {
    return this.data.personal.gender
  }

  set gender(val) {
    return this.data.personal.gender = val
  }

  get birthDate() {
    return this.data.personal.dob
  }

  set birthDate(val) {
    return this.data.personal.dob = val
  }

  get email() {
    return this.data.contact.email
  }

  set email(val) {
    return this.data.contact.email = val
  }

  get phone() {
    return this.data.contact.tel
  }

  set phone(val) {
    return this.data.contact.tel = val
  }

  get postcode() {
    if (!this.data.contact.address) {
      return ''
    }
    return this.data.contact.address.postcode
  }

  set postcode(val) {
    if (!this.data.contact.address) {
      this.data.contact.address = {}
    }
    return this.data.contact.address.postcode = val
  }

  get emailMarketing() {
    return this.data.consent.email_marketing
  }

  set emailMarketing(val) {
    return this.data.consent.email_marketing = val
  }

  get pushNotifications() {
    return this.data.consent.push_notifications
  }

  set pushNotifications(val) {
    return this.data.consent.push_notifications = val
  }

  get termsAccept() {
    return this.data.consent.accepted_single_id_terms
  }

  set termsAccept(val) {
    this.data.consent.single_id_terms_version = "1.0.0"
    return this.data.consent.accepted_single_id_terms = val
  }

  get voucherCode() {
    return this.data.identifiers.signup_code
  }

  set voucherCode(val) {
    return this.data.identifiers.signup_code = val
  }

  set password(val) {
    return this.data.security.password = val
  }

  set identifier(val) {
    return this.data.identifiers = { ...this.data.identifiers, ...val }
  }

  get accountNumber() {
    return this.data.identifiers.account_number
  }
}

export default User
